import { AppProps } from '../../App'
import { useTranslation } from 'react-i18next';
import { appName } from '../../utils/constants';
import { BoldHeader3, Title } from '../../components/General';
import { useNavigate } from 'react-router-dom';

const customerPortalUrl = process.env.REACT_APP_ENV === 'dev' ? 'https://billing.stripe.com/p/login/test_9AQ7wu3aZ9DYare3cc' : 'https://billing.stripe.com/p/login/5kAeVB2MMfEV98s7ss';

const PlanAndPayments = (props: AppProps) => {

  const { t } = useTranslation();
  const navigate = useNavigate();

  return (
    <>
      <Title>{t('settings.plan-and-payments.title')}</Title>
      <div className='mt-8 max-w-3xl'>
        {/* current plan */}
        <BoldHeader3>{t('pricing.your-current-plan')}</BoldHeader3>
        {props.user?.plan.name !== 'free' ? <>
          <div className='mt-2 text-sm md:text-base'>{appName} Pro</div>
          <div className='mt-4'>
            <button onClick={() => window.open(`${customerPortalUrl}?prefilled_email=${props.user?.email}`)} className='text-xs border py-2 px-8 rounded-lg'>{t('settings.plan-and-payments.cancel-plan')}</button>
          </div>
        </> : <>
          <div className='text-sm font-light my-1'>{t('settings.plan-and-payments.no-plan')}</div>
        </>}
        {props.user?.plan.name === 'free' && <div className='mt-4'><button onClick={() => navigate('/pricing')} className='text-xs text-white bg-primary py-2 px-8 rounded-lg'>{t('pricing.upgrade')}</button></div>}
        <div className='border-b my-8' />
        {/* payment methods */}
        {/* <BoldHeader3>{t('settings.plan-and-payments.payment-methods')}</BoldHeader3>
        {paymentMethods.length > 0 ? <>
        
        </> : <div className='text-sm font-light mt-4'>{t('settings.plan-and-payments.no-payment-methods')}</div>}
        <div className='mt-4'><button className='text-xs border py-2 px-8 rounded-lg'>{t('settings.plan-and-payments.add-payment-method')}</button></div>
        <div className='border-b my-8' /> */}
        {/* billing history */}
        {/* <BoldHeader3>{t('settings.plan-and-payments.billing-history')}</BoldHeader3>
        <div className='mt-4'><button className='text-xs border py-2 px-8 rounded-lg'>{t('settings.plan-and-payments.view-billing-history')}</button></div> */}
      </div>
    </>
  )
}

export default PlanAndPayments